(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(44065);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ TitleAs; }
/* harmony export */ });
var TitleAs;
(function(TitleAs) {
    TitleAs["h1"] = "h1";
    TitleAs["h2"] = "h2";
    TitleAs["h3"] = "h3";
    TitleAs["h4"] = "h4";
    TitleAs["h5"] = "h5";
    TitleAs["h6"] = "h6";
})(TitleAs || (TitleAs = {}));


/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 44065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./styles/pages/styled/home.styles.tsx

const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1k3ekjc0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
// EXTERNAL MODULE: ./node_modules/emotion-rgba/dist/index.js
var dist = __webpack_require__(49484);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
// EXTERNAL MODULE: ./styledComponents/LinkButtonWithGradientHover/index.ts + 2 modules
var LinkButtonWithGradientHover = __webpack_require__(68413);
;// CONCATENATED MODULE: ./components/sections/Showreel/showreel.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 4rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 7.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: auto;\n    flex: 0 0 25%;\n    margin-top: 0;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 15%;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 20%;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 75%;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 85%;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 80%;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    left: auto;\n    right: 0;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      position: fixed;\n      align-items: center;\n      justify-content: center;\n      right: 0;\n      bottom: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 100;\n      border-radius: 0;\n      background-color: ",
        ";\n      display: flex;\n      cursor: default;\n\n      > * {\n        border-radius: 0;\n      }\n    "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 2rem;\n  "
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 4rem;\n    cursor: none;\n  "
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      height: 100%;\n      cursor: default;\n    "
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    transform: none;\n    opacity: 0;\n  "
    ]);
    _templateObject13 = function() {
        return data;
    };
    return data;
}
function _templateObject14() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 9rem;\n    width: 9rem;\n  "
    ]);
    _templateObject14 = function() {
        return data;
    };
    return data;
}
function _templateObject15() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n    height: 9rem;\n    width: 9rem;\n  "
    ]);
    _templateObject15 = function() {
        return data;
    };
    return data;
}
function _templateObject16() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 15.1875rem;\n    padding: 0.75rem 0;\n  "
    ]);
    _templateObject16 = function() {
        return data;
    };
    return data;
}







const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "eg1vjnl0"
})(mixins/* defaultContainerSize */.sX, ";display:flex;flex-wrap:wrap;padding-top:2.5rem;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const FeaturesContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg1vjnl1"
})("flex:0 0 100%;position:relative;height:2rem;margin-top:1.5rem;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xxxLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const Features = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg1vjnl2"
})("overflow:hidden;position:absolute;width:100%;height:2rem;bottom:0;right:0;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "eg1vjnl3"
})(Typography/* Header1 */.R6, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";flex:0 0 100%;align-items:flex-end;margin:0;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";", mixins.mq.xxxLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const Span = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "eg1vjnl4"
})(Typography/* Subheader */.fi, ";display:block;");
const featureAutoplay = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{top:-100%;opacity:0;}3%{opacity:0;}5%{top:0;opacity:1;}33.33%{top:0;opacity:1;}35.33%{opacity:0;}37.33%{top:100%;opacity:0;}100%{top:100%;opacity:0;}");
const Feature = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "eg1vjnl5"
})(Typography/* ParagraphM */.Sl, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0;position:absolute;left:0;top:-120%;animation:12s ", featureAutoplay, " infinite ease-in-out;user-select:none;&:nth-child(1){animation-delay:0s;}&:nth-child(2){animation-delay:4s;}&:nth-child(3){animation-delay:8s;}", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";");
const Gradient = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "eg1vjnl6"
})("background:linear-gradient(\n    67.33deg,", theme/* THEME.colors.primary */.C.colors.primary, " -19.99%,", theme/* THEME.colors.accent */.C.colors.accent, " 98.54%\n  );background-clip:text;color:", (0,dist.rgba)(theme/* THEME.colors.core_white */.C.colors.core_white, 0), ";position:relative;");
const VideoContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg1vjnl7"
})("margin:2.5rem 0 0 0;position:relative;border-radius:1rem;flex:0 0 100%;cursor:pointer;z-index:0;> *{border-radius:1rem;}", (param)=>{
    let { isFullscreen  } = param;
    return isFullscreen && (0,emotion_react_browser_esm/* css */.iv)(_templateObject9(), theme/* THEME.colors.core_black */.C.colors.core_black);
}, ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject10())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject11())), ";");
const Video = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("video", {
    target: "eg1vjnl8"
})("border-radius:1rem;width:100%;height:auto;", (param)=>{
    let { isFullscreen  } = param;
    return isFullscreen && (0,emotion_react_browser_esm/* css */.iv)(_templateObject12());
}, ";");
const Cursor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg1vjnl9"
})("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transition:opacity 300ms ease-in-out;opacity:1;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject13())), ";");
const Play = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", {
    target: "eg1vjnl10"
})("height:6rem;width:6rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);pointer-events:none;transition:height 300ms ease-in-out,width 300ms ease-in-out;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject14())), ";");
const Caption = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", {
    target: "eg1vjnl11"
})("height:6rem;width:6rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:2;display:none;pointer-events:none;transition:height 300ms ease-in-out,width 300ms ease-in-out;font-weight:bold;font-size:3.7rem;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject15())), ";");
const CloseButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eg1vjnl12"
})("top:60px;right:40px;position:fixed;width:2rem;height:2rem;cursor:pointer;transition:background-color 200ms ease-in-out;border-radius:0.0625rem;&:before{transform:rotate(-45deg);}&:after{transform:rotate(45deg);}&:before,&:after{content:'';position:absolute;height:3px;width:100%;top:50%;left:0;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";border-radius:0.0625rem;transition:background-color 200ms ease-in-out;box-shadow:0 0 4px 0.0625rem #1700594a;}&:hover{-webkit-background-clip:text;&:before,&:after{height:3px;background:linear-gradient(\n        88.48deg,#0f4ed7 0%,#684b9f 59.57%,#d2485c 98.61%\n      );}}");
const StyledLinkButtonWithGradientHover = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(LinkButtonWithGradientHover/* default */.Z, {
    target: "eg1vjnl13"
})("transition:background-color 3000ms ease-in-out;margin-top:2rem;padding:0.5rem 0rem;max-width:11.75rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject16())), ";&:hover{background:linear-gradient(\n      67.33deg,", theme/* THEME.colors.primary */.C.colors.primary, " -19.99%,", theme/* THEME.colors.accent */.C.colors.accent, " 98.54%\n    );}");

// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(21977);
;// CONCATENATED MODULE: ./components/sections/Showreel/showreel.hooks.tsx


const useShowreel = ()=>{
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const cursorRef = (0,react.useRef)(null);
    const previewVideoRef = (0,react.useRef)(null);
    const [initialized, setInitialized] = (0,react.useState)(false);
    const [isPreview, setPreview] = (0,react.useState)(true);
    const [isSafari, setSafari] = (0,react.useState)(true);
    const animateCursor = (event, ref, windowSize)=>{
        // @ts-ignore
        const paths = event.composedPath();
        if (!paths) return;
        if ((windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) && windowSize.width < 1200) return;
        if (!ref.current) return;
        if (// @ts-ignore
        paths.some((path)=>{
            if (!(path === null || path === void 0 ? void 0 : path.classList)) return false;
            const classList = Array.from(path.classList);
            return classList.includes("showreel__video") || classList.includes("showreel__caption") || classList.includes("showreel__play");
        })) {
            ref.current.style.left = "".concat(event.offsetX, "px");
            ref.current.style.top = "".concat(event.offsetY, "px");
            ref.current.style.opacity = "1";
            ref.current.style.cursor = "none";
        } else {
            ref.current.style.opacity = "0";
        }
    };
    (0,react.useEffect)(()=>{
        const handleKeyDown = (evt)=>{
            if (evt.code === "Escape") {
                setPreview(true);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        const ua = navigator.userAgent.toLowerCase();
        const is_safari = ua.indexOf("safari/") > -1 && ua.indexOf("chrome") < 0;
        setSafari(is_safari);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if ((windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) && !initialized) {
            setInitialized(true);
        }
    }, [
        windowSize.width
    ]);
    (0,react.useEffect)(()=>{
        if (windowSize.width && !initialized) {
            window.addEventListener("mousemove", (event)=>animateCursor(event, cursorRef, windowSize));
            return ()=>{
                window.removeEventListener("mousemove", (event)=>animateCursor(event, cursorRef, windowSize));
            };
        }
    }, [
        windowSize.width
    ]);
    (0,react.useEffect)(()=>{
        if ((cursorRef === null || cursorRef === void 0 ? void 0 : cursorRef.current) && windowSize.width && windowSize.height) {
            cursorRef.current.style.top = "50%";
            cursorRef.current.style.left = "50%";
            cursorRef.current.style.transform = "translate(-50%, -50%)";
            cursorRef.current.style.opacity = windowSize.width < 1200 ? "1" : "0";
        }
    }, [
        windowSize.width,
        windowSize.height
    ]);
    function handleShowreelClick() {
        setPreview((prev)=>!prev);
    }
    (0,react.useEffect)(()=>{
        if (previewVideoRef === null || previewVideoRef === void 0 ? void 0 : previewVideoRef.current) {
            // @ts-ignore
            previewVideoRef.current.volume = 0.2;
            try {
                if (isPreview && (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) && windowSize.width <= 1200) {
                    var // TODO: add is currently playing property
                    _previewVideoRef_current;
                    (_previewVideoRef_current = previewVideoRef.current) === null || _previewVideoRef_current === void 0 ? void 0 : _previewVideoRef_current.pause();
                } else {
                    var _previewVideoRef_current1;
                    (_previewVideoRef_current1 = previewVideoRef.current) === null || _previewVideoRef_current1 === void 0 ? void 0 : _previewVideoRef_current1.play();
                }
            } catch (e) {
                console.error("Could not change the video play state!");
            }
        }
    }, [
        windowSize.width,
        isPreview
    ]);
    return {
        handleShowreelClick,
        previewVideoRef,
        isPreview,
        isSafari,
        setPreview,
        cursorRef
    };
};

;// CONCATENATED MODULE: ./components/sections/Showreel/Showreel.tsx




const Showreel = (param)=>{
    let { title , subtitle , items , cursorCaption , contact_us  } = param;
    var _contact_us_action_link;
    const { isPreview , setPreview , previewVideoRef , cursorRef , isSafari , handleShowreelClick  } = useShowreel();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
                children: [
                    title && prismic_reactjs.RichText.asText(title),
                    subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Span, {
                        children: prismic_reactjs.RichText.asText(subtitle)
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeaturesContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Features, {
                    children: items.map((item)=>{
                        const gradientText = prismic_reactjs.RichText.asText(item.gradient_text);
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Feature, {
                            children: [
                                prismic_reactjs.RichText.asText(item.text),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Gradient, {
                                    children: gradientText
                                })
                            ]
                        }, gradientText);
                    })
                })
            }),
            (contact_us === null || contact_us === void 0 ? void 0 : (_contact_us_action_link = contact_us.action_link) === null || _contact_us_action_link === void 0 ? void 0 : _contact_us_action_link.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLinkButtonWithGradientHover, {
                href: contact_us.action_link.url,
                children: prismic_reactjs.RichText.asText(contact_us === null || contact_us === void 0 ? void 0 : contact_us.action_label)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VideoContainer, {
                isFullscreen: !isPreview,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Video, {
                        preload: "none",
                        ref: previewVideoRef,
                        autoPlay: true,
                        loop: true,
                        controls: !isPreview,
                        muted: isPreview,
                        playsInline: true,
                        isFullscreen: !isPreview,
                        className: "showreel__video",
                        onClick: isPreview ? handleShowreelClick : ()=>{},
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                            src: "/videos/showreel".concat(isPreview ? "_preview" : isSafari ? "-acc" : "", ".mp4").concat(isSafari && !isPreview ? "#t=0.1" : ""),
                            type: "video/mp4"
                        })
                    }, isPreview ? "_preview" : ""),
                    !isPreview && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
                        onClick: ()=>setPreview((prev)=>!prev)
                    }),
                    isPreview && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Cursor, {
                        ref: cursorRef,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Play, {
                                className: "showreel__play",
                                width: "144",
                                height: "144",
                                viewBox: "0 0 144 144",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M72 115C96.3005 115 116 95.3005 116 71C116 46.6995 96.3005 27 72 27C47.6995 27 28 46.6995 28 71C28 95.3005 47.6995 115 72 115ZM61 54V86L89.5867 70.2133L61 54Z",
                                    fill: "black"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Caption, {
                                viewBox: "0 0 400 400",
                                className: "showreel__caption",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            id: "MyPath",
                                            d: "M 130, 200 m -80, 0 a 100,95 0 1,1 315,0"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("text", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("textPath", {
                                            href: "#MyPath",
                                            children: prismic_reactjs.RichText.asText(cursorCaption)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/sections/Showreel/index.ts

/* harmony default export */ var sections_Showreel = (Showreel);

// EXTERNAL MODULE: ./models/enums/titleAs.ts
var titleAs = __webpack_require__(79794);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/sections/CoverWithInfo/coverWithInfo.styles.ts

function coverWithInfo_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0rem;\n    width: 100%;\n  "
    ]);
    coverWithInfo_styles_templateObject = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    left: 0;\n  "
    ]);
    coverWithInfo_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 42%;\n  "
    ]);
    coverWithInfo_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 45%;\n  "
    ]);
    coverWithInfo_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    left: 0%;\n    top: 0%;\n    transform: translate(0%, 0%);\n    padding-top: 18.7rem;\n    padding-left: 6.313rem;\n  "
    ]);
    coverWithInfo_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 1.75rem;\n    line-height: 2.25rem;\n    padding-right: 2rem;\n    max-width: 20rem;\n  "
    ]);
    coverWithInfo_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 2rem;\n    max-width: 20rem;\n  "
    ]);
    coverWithInfo_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 0rem;\n    max-width: 30rem;\n  "
    ]);
    coverWithInfo_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 0rem;\n    flex: 0 0 70%;\n    max-width: 32rem;\n  "
    ]);
    coverWithInfo_styles_templateObject8 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 70%;\n    max-width: 32rem;\n  "
    ]);
    coverWithInfo_styles_templateObject9 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 65%;\n    margin: 0rem 0rem 1.8rem 0rem;\n    max-width: 45rem;\n  "
    ]);
    coverWithInfo_styles_templateObject10 = function() {
        return data;
    };
    return data;
}
function coverWithInfo_styles_templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 15.1875rem;\n    padding: 0.75rem 0;\n  "
    ]);
    coverWithInfo_styles_templateObject11 = function() {
        return data;
    };
    return data;
}







const coverWithInfo_styles_Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "eedfwta0"
})("margin:0 auto;padding:0rem 1rem;max-width:77.125rem;width:calc(100% -2rem);max-height:41.125rem;heigth:100%;overflow:hidden;position:relative;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject())), ";");
const StyledImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "eedfwta1"
})("width:100%;");
const StyledContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eedfwta2"
})("position:absolute;width:100%;height:100%;top:0rem;left:0;padding:0rem 1rem;margin:0 auto;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject1())), ";");
const StyledContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eedfwta3"
})("position:absolute;padding:0;left:50%;top:33%;width:85%;transform:translate(-50%,-50%);", mixins.mq.mSmall((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject2())), ";", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject3())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject4())), ";");
const Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eedfwta4"
})("margin:0 auto;");
const coverWithInfo_styles_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "eedfwta5"
})(mixins.mq.mSmall((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject5())), ";", Typography/* Header1 */.R6, ";font-size:1.5rem;line-height:2rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";flex:0 0 100%;align-items:flex-end;margin:0rem 0rem 0.5rem 0rem;padding-right:2rem;max-width:23rem;", mixins.mq.smallIp((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject6())), ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject7())), ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject8())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject9())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject10())), ";");
const coverWithInfo_styles_StyledLinkButtonWithGradientHover = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(LinkButtonWithGradientHover/* default */.Z, {
    target: "eedfwta6"
})("transition:background-color 3000ms ease-in-out;position:absolute;padding:0.5rem 0rem;max-width:11.75rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(coverWithInfo_styles_templateObject11())), ";&:hover{background:linear-gradient(\n      67.33deg,", theme/* THEME.colors.primary */.C.colors.primary, " -19.99%,", theme/* THEME.colors.accent */.C.colors.accent, " 98.54%\n    );}");

// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
;// CONCATENATED MODULE: ./components/sections/CoverWithInfo/CoverWithInfo.tsx





const CoverWithInfo = (param)=>{
    let { contactButton , title , backgroundImage  } = param;
    var _contactButton_action_link;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(coverWithInfo_styles_Section, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                ...(0,imageSerializer/* imageSerializer */.l)(backgroundImage)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContentWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(coverWithInfo_styles_Title, {
                                children: prismic_reactjs.RichText.asText(title)
                            }),
                            (contactButton === null || contactButton === void 0 ? void 0 : (_contactButton_action_link = contactButton.action_link) === null || _contactButton_action_link === void 0 ? void 0 : _contactButton_action_link.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(coverWithInfo_styles_StyledLinkButtonWithGradientHover, {
                                href: contactButton.action_link.url,
                                children: prismic_reactjs.RichText.asText(contactButton === null || contactButton === void 0 ? void 0 : contactButton.action_label)
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx








const DynamicWhoWeAre = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2273).then(__webpack_require__.bind(__webpack_require__, 22273)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(22273)
            ]
    }
});
const DynamicProjects = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5871).then(__webpack_require__.bind(__webpack_require__, 45871)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45871)
            ]
    }
});
const DynamicFaq = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6140).then(__webpack_require__.bind(__webpack_require__, 56140)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(56140)
            ]
    }
});
const DynamicTrustedBy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4575), __webpack_require__.e(6121), __webpack_require__.e(7878)]).then(__webpack_require__.bind(__webpack_require__, 9368)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9368)
            ]
    }
});
const Home = (param)=>/*#__PURE__*/ {
    let { data: { page  }  } = param;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sections_Showreel, {
                    title: page.showreel_title,
                    subtitle: page.showreel_subtitle,
                    cursorCaption: page.showreel_cursor_caption,
                    items: page.showreel_features,
                    contact_us: page.contact_us
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicTrustedBy, {
                    companiesTitle: prismic_reactjs.RichText.asText(page.howWeMakeItWork_companiesTitle),
                    companies: page.howWeMakeItWork_companies
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicWhoWeAre, {
                    title: page.whoWeAre_title,
                    highlightedDescription: page.whoWeAre_highlightedDescription,
                    description: page.whoWeAre_description,
                    descriptionSecondary: page.whoWeAre_descriptionSecondary,
                    buttonLabel: page.whoWeAre_button
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CoverWithInfo, {
                    title: page.coverWithInfo_title,
                    backgroundImage: page.coverWithInfo_backgroundImage,
                    contactButton: page.coverWithInfo_contactButton
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicProjects, {
                    title: prismic_reactjs.RichText.asText(page.projects_title),
                    description: page.projects_description,
                    items: page.projects,
                    titleAs: titleAs/* TitleAs.h3 */.P.h3
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicFaq, {
                    title: prismic_reactjs.RichText.asText(page.faq_title),
                    items: page.faq_items,
                    titleAs: titleAs/* TitleAs.h4 */.P.h4
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 68413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styledComponents_LinkButtonWithGradientHover; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./styledComponents/LinkButtonWithGradientHover/linkButtonWithGradientHover.styles.tsx



const StyledLinkButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((link_default()), {
    target: "e1ar47xz0"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";position:relative;width:100%;max-width:15.1875rem;border-radius:3.75rem;padding:0.75rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";text-decoration:none;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";transition:background-color 300ms ease-in-out;text-align:center;font-size:1.25rem;line-height:2rem;letter-spacing:0.0125rem;cursor:pointer;", (param)=>{
    let { maxWidth  } = param;
    return maxWidth && /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:", maxWidth, "px;");
}, ";", (param)=>{
    let { fillButton  } = param;
    return fillButton && /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;max-width:unset;");
}, ";", (param)=>{
    let { fit  } = param;
    return fit && /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:fit-content;max-width:unset;");
}, ";&:after{content:'';box-shadow:0.5rem 0.5rem 1.5rem rgba(65,70,176,0.86);opacity:0;transition:opacity 300ms ease-in-out;display:block;height:100%;width:100%;position:absolute;top:0;left:0;border-radius:4rem;z-index:0;}&:hover{&:after{opacity:1;}}&:before{content:'';width:100%;height:100%;border-radius:3.75rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);position:absolute;top:0;left:0;z-index:-1;}&:hover{background-color:transparent;}");

;// CONCATENATED MODULE: ./styledComponents/LinkButtonWithGradientHover/LinkButtonWithGradientHover.tsx


const LinkButtonWithGradientHover = (param)=>{
    let { children , onClick , disabled , fillButton , fit , as , href , ...props } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLinkButton, {
        disabled: disabled,
        fillButton: fillButton,
        fit: fit,
        onClick: onClick,
        as: as,
        href: href,
        ...props,
        children: children
    });
};

;// CONCATENATED MODULE: ./styledComponents/LinkButtonWithGradientHover/index.ts

/* harmony default export */ var styledComponents_LinkButtonWithGradientHover = (LinkButtonWithGradientHover);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);